import tv from '~/lib/tv'

const focusRing = tv({
  variants: {
    isFocusVisible: {
      false: 'outline-0',
      true: 'outline-2',
    },
  },
})

export default focusRing
